import {
  createCategory,
  deleteCategory,
  listCategories,
  listCategoriesNext,
  listOptionCategories,
  updateCategory,
} from '../thunks/marketplace-categories';
import { handlePending, handleRejected } from './utils';

export const marketplaceCategoriesReducers = (builder) => {
  // list categories
  builder
    .addCase(listCategories.fulfilled, (state, action) => {
      const categories = action.payload?.data || [];
      const offset = action.payload?.offset || 0;
      state.categories.value = categories;
      state.categories.offset = offset;
      state.categories.hasMore = categories.length > 0;
      state.categories.loading = false;
      state.categories.initialised = true;
    })
    .addCase(listCategories.pending, (state) => {
      if (!state.categories.initialised) {
        state.categories.loading = true;
      }
    })
    .addCase(listCategories.rejected, (state) => handleRejected(state, 'categories'));

  builder
    .addCase(listCategoriesNext.fulfilled, (state, action) => {
      const categories = action.payload?.data || [];
      const offset = action.payload?.offset || 0;
      state.categories.value = [...state.categories.value, ...categories];
      state.categories.offset = offset;
      state.categories.hasMore = categories.length > 0;
      state.categories.loading = false;
      state.categories.initialised = true;
    })
    .addCase(listCategoriesNext.pending, (state) => {
      if (!state.categories.initialised) {
        state.categories.loading = true;
      }
    })
    .addCase(listCategoriesNext.rejected, (state) => handleRejected(state, 'categories'));

  // list option categories
  builder
    .addCase(listOptionCategories.fulfilled, (state, action) => {
      state.options.categories.value = action.payload || [];
      state.options.categories.loading = false;
    })
    .addCase(listOptionCategories.pending, (state) => {
      state.options.categories.loading = true;
    })
    .addCase(listOptionCategories.rejected, (state) => {
      state.options.categories.loading = false;
    });

  // create category
  builder
    .addCase(createCategory.fulfilled, (state, action) => {
      const categories = [...state.categories.value];
      const category = action.payload;
      categories.push(category);
      state.categories.value = categories;
      state.newCategoryForm.loading = false;
    })
    .addCase(createCategory.pending, (state) => handlePending(state, 'newCategoryForm'))
    .addCase(createCategory.rejected, (state) => handleRejected(state, 'newCategoryForm'));

  // update category
  builder
    .addCase(updateCategory.fulfilled, (state, action) => {
      const categories = [...state.categories.value];
      const updatedCategory = action.payload;
      const categoryIndex = categories.findIndex((category) => category.id === updatedCategory.id);
      if (categoryIndex >= 0) {
        categories[categoryIndex] = { ...categories[categoryIndex], ...updatedCategory };
      }
      state.categories.value = categories;
      state.newCategoryForm.loading = false;
    })
    .addCase(updateCategory.pending, (state) => handlePending(state, 'newCategoryForm'))
    .addCase(updateCategory.rejected, (state) => handleRejected(state, 'newCategoryForm'));

  // delete category
  builder.addCase(deleteCategory.fulfilled, (state, action) => {
    const categories = [...state.categories.value];
    const categoryId = action.payload;
    const categoryIndex = categories.findIndex((category) => category.id === categoryId);
    if (categoryIndex >= 0) {
      categories.splice(categoryIndex, 1);
    }
    state.categories.value = categories;
  });
};
